var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.778,
    height: 16,
    viewBox: "0 0 17.778 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-door",
    d: "M10.889,3A1.772,1.772,0,0,0,9.111,4.778H2.889V17.222H2V19H19.778V17.222h-.889V4.778A1.772,1.772,0,0,0,17.111,3H10.889m0,1.778h6.222V17.222H10.889V4.778M4.667,10.111H6.444v1.778H4.667Z",
    transform: "translate(-2 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoor);
export default __webpack_public_path__ + "static/media/icon-door.41edfa0849163dd4601e62e2eea9549b.svg";
export { ForwardRef as ReactComponent };